import { type FormEvent, useState } from 'react';
import { resetPassword } from '../api/client';
import { Field, Input } from '../components/form';
import { Alert, Button, Card } from '../components/ui';
import { ThemeSwitcher } from '../theme/ThemeSwitcher';
import styles from './screens.module.css';

/** Tela "Redefinir senha": consome o token do e-mail e define a nova senha. */
export function RedefinirSenha({ token, onDone }: { token: string; onDone: () => void }) {
  const [senha, setSenha] = useState('');
  const [confirma, setConfirma] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [ok, setOk] = useState(false);
  const [enviando, setEnviando] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    if (senha.length < 8) {
      setErro('A nova senha precisa de pelo menos 8 caracteres.');
      return;
    }
    if (senha !== confirma) {
      setErro('As senhas não conferem.');
      return;
    }
    setEnviando(true);
    const res = await resetPassword(token, senha);
    setEnviando(false);
    if (res.ok) {
      setOk(true);
      setTimeout(onDone, 1200);
    } else if (res.status === 400) {
      setErro('Link inválido ou expirado. Solicite um novo.');
    } else {
      setErro('Não foi possível redefinir a senha.');
    }
  }

  return (
    <div className={styles.centerScreen}>
      <Card className={styles.authCard}>
        <div className={styles.authHead}>
          <span className={styles.brand}>eCondomínio</span>
          <ThemeSwitcher compact />
        </div>
        <h1>Criar nova senha</h1>
        {ok ? (
          <>
            <Alert kind="success">Senha redefinida. Você já pode entrar.</Alert>
            <div style={{ marginTop: 'var(--space-4)' }}>
              <Button block onClick={onDone}>
                Ir para o login
              </Button>
            </div>
          </>
        ) : (
          <form onSubmit={onSubmit} noValidate>
            <Field label="Nova senha (mín. 8 caracteres)">
              {(id) => (
                <Input
                  id={id}
                  type="password"
                  autoComplete="new-password"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                />
              )}
            </Field>
            <Field label="Confirmar nova senha">
              {(id) => (
                <Input
                  id={id}
                  type="password"
                  autoComplete="new-password"
                  value={confirma}
                  onChange={(e) => setConfirma(e.target.value)}
                />
              )}
            </Field>
            {erro ? <Alert kind="danger">{erro}</Alert> : null}
            <div style={{ marginTop: 'var(--space-4)' }}>
              <Button type="submit" block disabled={enviando}>
                {enviando ? 'Salvando…' : 'Redefinir senha'}
              </Button>
            </div>
            <div style={{ marginTop: 'var(--space-3)' }}>
              <Button block variant="ghost" onClick={onDone}>
                Voltar para o login
              </Button>
            </div>
          </form>
        )}
      </Card>
    </div>
  );
}
